import React from 'react';

import { MY_COURSES_MODE } from 'Domain/MyCourseData';

import { QueryComponent } from '../../../../GraphQL';
import { myCourses } from '../../../../GraphQL/query/Product.query';
import { sortCoursesByDate } from '../../../../Util/course';

import CourseBannerView from './CourseBanner';

const CourseBanner = ({ t, user, onCourseCardClick }) => {
  return (
    <QueryComponent query={myCourses} variables={{ mode: MY_COURSES_MODE.ALL }}>
      {(data) => {
        const courses = data.myCourses;
        const sortedCourses = sortCoursesByDate(
          courses,
          `courseInfo.classroomProgress.lastEnterAt`,
          true
        );
        return (
          <CourseBannerView
            courses={sortedCourses}
            onCourseCardClick={(id, mode) => onCourseCardClick(id, mode)}
            user={user}
          />
        );
      }}
    </QueryComponent>
  );
};

export default CourseBanner;
